export default __webpack_public_path__ + "details-light.svg";